var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { createStyles, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import Maintenance from "./Maintenance";
import EntryModal from "./EntryModal";
import MainNav from "./MainNav";
import SubNav from "./SubNav";
import MobileNav from "./MobileNav";
import AuthProvider from "../AuthProvider";
var useStyles = makeStyles(function (_a) {
    var zIndex = _a.zIndex;
    return createStyles({
        header: {
            zIndex: zIndex.appBar,
            position: "relative",
        },
        background: {
            backgroundImage: function (props) {
                return props.background === "transparent" ? "transparent" : "linear-gradient(to bottom right, #e6007d, #e72647)";
            },
        },
    });
});
var Header = function (_a) {
    var _b = _a.background, background = _b === void 0 ? "gradient" : _b, ssoHooks = _a.ssoHooks, shouldOverrideLogout = _a.shouldOverrideLogout;
    var styles = useStyles({ background: background });
    var theme = useTheme();
    var isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    return (React.createElement(AuthProvider, __assign({}, ssoHooks, { shouldOverrideLogout: shouldOverrideLogout }),
        React.createElement(Maintenance, null),
        React.createElement(EntryModal, null),
        React.createElement("header", { className: styles.header }, isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(MainNav, null),
            React.createElement("div", { id: "acm-header__sub-nav", className: styles.background },
                React.createElement(SubNav, null)))) : (React.createElement("div", { id: "acm-header__mobile-nav", className: styles.background },
            React.createElement(MobileNav, null))))));
};
export default Header;
